import { Trans } from "@lingui/react/macro";

interface CompanyContactInfoProps {
  email?: string;
  className?: string;
}

export default function CompanyContactInfo({
  email = "info@soluud.de",
  className = "",
}: CompanyContactInfoProps) {
  return (
    <div
      className={`bg-soluud-background border-soluud-border-subtle text-soluud-text-primary space-y-1 rounded-lg border p-4 text-sm ${className}`}
    >
      <p className="font-bold">Soluud UG (haftungsbeschränkt)</p>
      <p>Musterstraße 42</p>
      <p>10117 Berlin, Germany</p>
      <p>
        <Trans>Managing Director:</Trans> [Name]
      </p>
      <p>
        <Trans>Commercial Register:</Trans> [Amtsgericht], [HRB Number]
      </p>
      <p>
        <Trans>Email:</Trans>{" "}
        <a
          href={`mailto:${email}`}
          className="text-soluud-primary hover:underline"
        >
          {email}
        </a>
      </p>
    </div>
  );
}
